import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { SidebarWrapper, ComponentWrapper } from './ContextualSidebarStyles';
import VerticalNavigationMenuContainer from './VerticalNavigationMenu/VerticalNavigationMenuContainer';
import CollapseButton from './CollapseButton/CollapseButtonContainer';
import { externalHostSelector } from '../ConsumerArea/ConsumerAreaSelector';
import { EXTERNAL_HOST } from '../ConsumerArea/ConsumerAreaConstants';
import { useIsEmbeddedMobile } from '../_hooks/useIsEmbeddedMobile';

const ContextualSidebarView = ({ Component, className, ...props }) => {
  const { isCollapsed, isCollapsedWithButton } = props;

  const externalHost = useSelector(externalHostSelector);

  const hideVerticalNavigationMenu = [EXTERNAL_HOST.WEALTHCARE].includes(externalHost);

  const isEmbeddedMobile = useIsEmbeddedMobile();

  return (
    <SidebarWrapper
      className={className}
      isEmbeddedMobile={isEmbeddedMobile}
      css={{
        flexBasis: isCollapsed
          ? 81
          : isCollapsedWithButton
          ? hideVerticalNavigationMenu
            ? 20
            : 111
          : 391,
      }}
    >
      {!hideVerticalNavigationMenu && <VerticalNavigationMenuContainer />}

      <ComponentWrapper>
        {!isCollapsed && !isCollapsedWithButton && <Component {...props} />}
        {!isCollapsed && <CollapseButton />}
      </ComponentWrapper>
    </SidebarWrapper>
  );
};

ContextualSidebarView.defaultProps = {
  className: '',
};

ContextualSidebarView.propTypes = {
  isCollapsed: PropTypes.bool.isRequired,
  isCollapsedWithButton: PropTypes.bool.isRequired,
  Component: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default ContextualSidebarView;
